import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_BEGIN,
  SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_SUCCESS,
  SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_FAILURE,
  SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import axios from 'axios';

export function getListInternalProductSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      let url = `${config.apiRootUrl}/subscriptions/get-list-internal-product-subscription`;
      if (args.company) url += `?company=${args.company}`;

      const doRequest = axios.get(url, createAxiosConfigWithAuth(getState()));
      doRequest.then(
        (res) => {
          dispatch({
            type: SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetListInternalProductSubscriptionError() {
  return {
    type: SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useGetListInternalProductSubscription() {
  const dispatch = useDispatch();

  const {
    getListInternalProductSubscriptionPending,
    getListInternalProductSubscriptionError,
  } = useSelector(
    (state) => ({
      getListInternalProductSubscriptionPending:
        state.subscriptions.getListInternalProductSubscriptionPending,
      getListInternalProductSubscriptionError:
        state.subscriptions.getListInternalProductSubscriptionError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getListInternalProductSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetListInternalProductSubscriptionError());
  }, [dispatch]);

  return {
    getListInternalProductSubscription: boundAction,
    getListInternalProductSubscriptionPending,
    getListInternalProductSubscriptionError,
    dismissGetListInternalProductSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getListInternalProductSubscriptionPending: true,
        getListInternalProductSubscriptionError: null,
      };

    case SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        getListInternalProductSubscriptionPending: false,
        getListInternalProductSubscriptionError: null,
      };

    case SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        getListInternalProductSubscriptionPending: false,
        getListInternalProductSubscriptionError: action.data.error,
      };

    case SUBSCRIPTIONS_GET_LIST_INTERNAL_PRODUCT_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getListInternalProductSubscriptionError: null,
      };

    default:
      return state;
  }
}
